import styled from 'styled-components';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { TextBackgroundPhoto } from '@sections/guest-list/TextBackgroundPhoto';

export const GradientWrap = styled.div`
  height: 200vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);

  ${themeMediaQuery('below_sm')} {
    height: 150vh;
  }
`;

export const MoreTimeTogetherWrapper = styled(Box)`
  position: relative;
`;

export const StyledBackgroundPhoto = styled(TextBackgroundPhoto)`
  ${themeMediaQuery('below_sm')} {
    background-position-x: 10%;
  }
`;

export const TextWrapper = styled(Text)`
  text-align: center;
  max-width: 665px;
  margin: auto;
  ${themeMediaQuery('below_sm')} {
    font-size: 32px;
    padding: 10px;
    max-width: 375px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 885px;
  }
`;
